<script lang="ts">
import {defineComponent} from 'vue'
import { MediaLibraryCollection } from '@spatie/media-library-pro-vue2-collection';


export default defineComponent({
    name: "form-log-work-modal",
    props: {
        serviceOrderId: {
            type: [Number, String],
            required: true
        }
    },
    components: {
        MediaLibraryCollection,
    },


    data() {
        const today = new Date().toISOString().split('T')[0];
        return {
            loading: false,
            submitting: false,
            order: null,
            attachments: [], // initial-value für MediaLibraryCollection
            markCompleted: false,
            statusOptions: [
                { value: 'open',              label: this.$t?.('service.status.open') || 'Open' },
                { value: 'in_progress',       label: this.$t?.('service.status.in_progress') || 'In Progress' },
                { value: 'waiting_for_parts', label: this.$t?.('service.status.waiting_for_parts') || 'Waiting for Parts' },
                { value: 'completed',         label: this.$t?.('service.status.completed') || 'Completed' },
            ],
            form: {
                // weitere Felder (z. B. notes, duration, ...)
                time_spent: 30,
                worked_at: today,
                description: '',
                status: null,
                attachments: null, // wird beim @change gefüllt
            }

        };
    },
    computed: {
        spentHours: {
            get() {
                return Math.floor(this.form.time_spent / 60);
            },
            set(h) {
                const m = this.form.time_spent % 60;
                this.form.time_spent = (parseInt(h) * 60) + m;
            }
        },
        spentMinutes: {
            get() {
                return this.form.time_spent % 60;
            },
            set(m) {
                const h = Math.floor(this.form.time_spent / 60);
                this.form.time_spent = (h * 60) + parseInt(m);
            }
        },
        hourOptions() {
            return Array.from({ length: 25 }, (_, i) => i); // 0-24 Stunden
        },
        minuteOptions() {
            return [0, 10, 20, 30, 40, 50];
        }
    },
    mounted() {
        this.fetchOrder(this.serviceOrderId);

    },
    watch: {
        serviceOrderId(newId) {
            this.fetchOrder(newId);
        }

    },
    methods: {
        async fetchOrder(serviceOrderId) {
            if (!serviceOrderId) return;
            this.loading = true;
            try {
                const { data } = await axios.get(`/api/service-orders/${serviceOrderId}`);
                const payload = data?.data ?? data;
                this.order = payload;
                this.form.status = payload.status;

                // Bestehende Anhänge in die richtige Collection filtern
                const media = Array.isArray(payload?.media) ? payload.media : [];
                this.attachments = media.filter(m => m.collection_name === 'ServiceOrderAttachment');
            } catch (e) {
                console.error('Fehler beim Laden der Service-Order', e);
                this.order = null;
                this.attachments = [];
            } finally {
                this.loading = false;
            }
        },

        async submitLog() {
            console.log("submitLog", this.form);
            this.submitting = true;
            if (this.markCompleted) {
                this.form.status = 'completed'
            }
            try {
                const res = await axios.post(
                    `/api/service-orders/${this.serviceOrderId}/service-logs`,
                    this.form
                )

                const newLog = res?.data?.data || res?.data || null

                this.onClose()

                this.$emit('servicelog-created', {
                    serviceOrderId: this.serviceOrderId,
                    log: newLog
                })






            } catch (e) {
                console.error('Fehler beim Speichern der Log-Work-Daten', e)
            } finally {
                this.submitting = false
            }
        },

        formatTimeSpent(minutes) {
            if (!minutes && minutes !== 0) return '-';
            if (minutes < 120) {
                return `${minutes} ${this.$t('general.minutes') || 'minutes'}`;
            }
            const h = Math.floor(minutes / 60);
            const m = minutes % 60;
            if (m === 0) {
                return `${h} ${this.$t('general.hours') || 'hours'}`;
            }
            return `${h} ${this.$t('general.hours') || 'hours'} ${m} ${this.$t('general.minutes') || 'minutes'}`;
        },

        onAttachmentsChange(changedMedia) {
            // Spatie erwartet das „temporary upload“ Array hier
            this.form.attachments = changedMedia;
        },

        onMarkCompletedChange() {
            if (this.markCompleted) {
                this.form.status = 'completed'
            }
        },


        onClose() {
            this.$emit('close');
        }
    }
})
</script>

<template>
    <div>
        <div class="ash-modal-overlay" id="ash-modal-overlay">
            <div class="ash-modal-content">
                <div class="bulk-return-modal">
                    <div class="modal-header">
                        <h5 class="modal-title">Log work on service order</h5>
                        <button class="close-button" @click="onClose">×</button>
                    </div>

                    <section class="modal-body">
                        <div v-if="loading">{{ $t('general.loading') }}</div>
                        <div v-else>
                            <!-- Beispiel: Anzeige der Order-Infos -->
                            <p v-if="order"><strong>{{ $t('service.grid.number') }}:</strong> {{ order.number }}</p>
                            <p v-if="order"><strong>{{ $t('service.grid.description') }}:</strong> {{ order.description }}</p>

                            <!-- Dein Formular für die Arbeitszeiterfassung -->
                            <form @submit.prevent="submitLog">
                                <!-- Felder hier… -->

                                <!-- Datum der Durchführung -->
                                <div class="form-group">
                                    <label>{{ $t('servicelog.form.worked_at') }}</label>
                                    <input type="date"
                                           class="form-control"
                                           v-model="form.worked_at" />
                                </div>

                                <div class="form-group">
                                    <label>
                                        {{ $t('servicelog.form.time_spent') || 'Time spent' }}
                                    </label>
                                    <div class="form-row">
                                        <div class="col-6">
                                            <div class="input-group">
                                                <select class="form-control" v-model="spentHours">
                                                    <option v-for="h in hourOptions" :key="h" :value="h">{{ h }}</option>
                                                </select>
                                                <div class="input-group-append">
                                                    <span class="input-group-text">{{ $t('general.hours') || 'h' }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="input-group">
                                                <select class="form-control" v-model="spentMinutes">
                                                    <option v-for="m in minuteOptions" :key="m" :value="m">{{ m }}</option>
                                                </select>
                                                <div class="input-group-append">
                                                    <span class="input-group-text">{{ $t('general.minutes') || 'm' }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="mt-1 text-muted">
                                        {{ formatTimeSpent(form.time_spent) }}
                                    </div>
                                </div>



                                <!-- Arbeitsdauer -->
                                <!--<div class="form-group">
                                    <label>{{ $t('servicelog.form.time_spent')}}</label>
                                    <input type="number"
                                           min="1"
                                           class="form-control"
                                           v-model.number="form.time_spent"
                                           placeholder="Enter minutes" />
                                </div>-->

                                <!-- Beschreibung -->
                                <div class="form-group">
                                    <label>{{ $t('servicelog.form.description')}}</label>
                                    <textarea class="form-control"
                                              rows="3"
                                              v-model="form.description"
                                              placeholder="What was done?"></textarea>
                                </div>

                                <!-- Status -->
                                <div class="form-group">
                                    <label>{{ $t('servicelog.form.change_status') }}</label>
                                    <select class="form-control"
                                            v-model="form.status">
                                        <option v-for="opt in statusOptions"
                                                :key="opt.value"
                                                :value="opt.value">
                                            {{ opt.label }}
                                        </option>
                                    </select>
                                </div>

                                <!-- NEU: Anhänge mit Spatie Media Library Pro -->
                                <div class="form-group mt-3">
                                    <label>{{ $t('servicelog.form.attachments') }}</label>
                                    <media-library-collection
                                        name="attachments"
                                        :initial-value="attachments"
                                        :max-items="20"
                                        :multiple="true"
                                        @change="onAttachmentsChange"
                                    />
                                </div>

                                <!-- Arbeit beendet Checkbox -->
                                <!--<div class="form-check mt-2">
                                    <input type="checkbox"
                                           class="form-check-input"
                                           id="markCompleted"
                                           v-model="markCompleted"
                                           @change="onMarkCompletedChange" />
                                    <label class="form-check-label" for="markCompleted">
                                        {{ $t('service.form.mark_completed') || 'Mark as completed' }}
                                    </label>
                                </div>-->

                            </form>
                        </div>
                    </section>


                    <div class="mt-3 d-flex justify-content-between">
                        <button class="btn btn-secondary" @click="$emit('close')">{{ $t('buttons.back-abort') }}</button>
                        <button v-if="order" type="button" class="btn btn-success" :disabled="submitting" @click="submitLog">
                            {{ submitting ? $t('general.saving') : $t('buttons.save') }}
                        </button>


                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.ash-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
}
.ash-modal-content {
    background: white;
    padding: 2rem;
    max-width: 960px;
    width: 100%;
    border-radius: 8px;
    max-height: 90vh;
    overflow-y: auto;
}

.bulk-return-modal {
    position: relative;
    padding: 1rem;
}
.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 1rem;
    border-bottom: 1px solid #ddd;
}
.modal-title {
    margin: 0;
    font-size: 1.2rem;
    font-weight: 600;
}
.btn {
    padding: 0.5em 1.2em;
    font-size: 1rem;
}
.close-button {
    font-size: 2rem;
    font-weight: bold;
    background: none;
    border: none;
    color: #666;
    cursor: pointer;
    line-height: 1;
}
</style>
